import { BvsBaseBoatInformationFormModel } from '@shared/models/forms/bvs-base-boat-information-form.model';
import { FormControl, Validators } from '@angular/forms';
import {
  BoatConstructionType,
  BoatType,
  CallidusBoatCountryRegistered,
  BoatMastMaterial,
  BoatSailingArea
} from '@backend/models';

export function createBvsBoatInformationBaseForm(): BvsBaseBoatInformationFormModel {
  return {
    boatType: new FormControl<BoatType | null>(null, Validators.required),
    boatConstructionType: new FormControl<BoatConstructionType | null>(null, Validators.required),
    manufacturer: new FormControl<string | null>(null),
    yachtType: new FormControl<string | null>(null),
    boatModel: new FormControl<string | null>(null, Validators.required),
    boatYard: new FormControl<string | null>(null, Validators.required),
    fullWidth: new FormControl<number | null>(null),
    fullLength: new FormControl<number | null>(null),
    isEnginePresent: new FormControl<boolean | null>(null),
    engineManufacturer: new FormControl<string | null>(null),
    engineModel: new FormControl<string | null>(null),
    engineFuelType: new FormControl<string | null>(null),
    engineHp: new FormControl<number | null>(null),
    builtInEngineCount: new FormControl<number | null>(null),
    builtInEngineHp: new FormControl<number | null>(null),
    extraEngineCount: new FormControl<number | null>(null),
    extraEngineHp: new FormControl<number | null>(null),
    mooringSummer: new FormControl<string | null>(null),
    mooringWinter: new FormControl<string | null>(null),
    isGutachtenPresent: new FormControl<boolean | null>(null),
    mastMaterial: new FormControl<BoatMastMaterial | null>(null),
    sailingArea: new FormControl<BoatSailingArea | null>(null, Validators.required),
    countryRegistered: new FormControl<CallidusBoatCountryRegistered | null>(null, Validators.required),
    isComfortAusstattungVorhanden: new FormControl<boolean | null>(null),
    isSailPresent: new FormControl<boolean | null>(null),
    sailSurfaceInMetersSquared: new FormControl<number | null>(null),
    maxKnotsOver40: new FormControl<boolean | null>(null),
    isBeibootVorhanden: new FormControl<boolean | null>(null, Validators.required),
    beibootHp: new FormControl<number | null>(null)
  };
}